import Loadable from '../../components/loadable';

const NewGrading = Loadable({
  loader: () => import('../../pages/gradings/new_grading'),
  type: 'block',
});

angular.module('gym').value('NewGrading', NewGrading);

const UnableToGradeModal = Loadable({
  loader: () => import('../../pages/gradings/unable_to_grade_modal'),
  type: 'modal',
});

angular.module('gym').value('UnableToGradeModal', UnableToGradeModal);
